import { Theme } from '@just-in-types';
import { Reducer } from 'redux';
import { SET_THEME } from '../actions';

export type ThemeState = Theme.Props;

const themeInitialState: Theme.Props = {
  background:
    'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6)), dodgerblue',
  colors: {
    error: 'red',
    primary: 'dodgerblue',
    secondary: 'white',
    success: 'mediumspringgreen',
    warning: 'orange',
  },
  logo:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
};

const themeReducer: Reducer = (
  state = themeInitialState,
  { type, payload },
) => {
  switch (type) {
    case SET_THEME:
      return payload;

    default:
      return { ...state };
  }
};

export default themeReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/themeReducer.ts